const getPercentFromValue = (value: number, max?: number) => {
  return `${Math.round((value / (max ?? 0)) * 100)} %`;
};

export default getPercentFromValue;
